<template>
  <div class="bg-gray-300 rounded-lg defaultstyles inline-block py-0 border-2 border-blue-500 mt-2 -mr-5 w-full flex flex-row flex-wrap justify-start flex-row-reverse">
    <h4 class="w-full inline-block p-0 m-0">
      <button class="w-full rounded-md bg-gray-900 hover:bg-gray-900 text-white p-2 pr-5 cursor-pointer text-left"
        @click.prevent="active = !active"
        :aria-expanded="active ? 'true' : 'false'"
        :aria-label="accordion_title + ' for ' + section_name + ' section'"
      >
        <i class="inline-block w-8 fill-current align-middle text-yellow-300">
          <polish-icon/>
        </i>

        <span class="text-base font-bold">
          {{ accordion_title }}
        </span>

        <span class="pl-3 leading-tight print:hidden" v-show="!active">
          <i aria-hidden="true" class="material-icons leading-tight text-xl p-0 align-middle">expand_more</i>
        </span>

        <span class="pl-3 text-red-300" v-show="active">
          <i aria-hidden="true" class="material-icons leading-tight align-middle">cancel</i>
        </span>
      </button>
    </h4>

    <div class="w-full ql-editor" v-show="active">
      <div class="flex flex-col sm:flex-row h-full">
        <div class="flex-1 py-3 px-3 xl:pr-10">
          <h5 v-if="selected_activity && selected_activity.name" class="text-xl font-bold mb-0 pt-0">
            {{ selected_activity.name }}
          </h5>
          <div class="leading-none mb-2">
            <span v-for="tag in selected_activity.tags" class="text-blue-600 text-xxs font-bold italic mr-1">
              #{{ tag }}
            </span>
          </div>
          <div v-if="selected_activity" v-html="selected_activity.instructions">
          </div>
        </div>

        <div v-if="show_tabs"
          class="w-full sm:w-1/4 h-full bg-gray-900 divide-y divide-gray-800"
        >
          <div v-for="(activity, index) in activities"
            class="cursor-pointer font-medium text-sm hover:bg-gray-300 hover:text-purple-600 border-t sm:border-t-0 leading-tight p-4 border-gray-800"
            :class="selection == index ? 'bg-gray-300 text-gray-900' : 'sm:border-l bg-gray-400 text-gray-800'"
            @click="select(index)"
          >
            {{ activity.name }}

            <div class="leading-none mt-1">
              <span v-for="tag in activity.tags" class="text-blue-600 text-xxs font-bold italic mr-1">
                #{{ tag }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
      activities: Array,
      section_name: {},
  },

  data () {
    return {
      active: false,
      selection: 0,
    }
  },

  computed: {
    selected_activity() {
      return this.activities[this.selection];
    },
    show_tabs() {
      return this.activities.length > 1;
    },
    accordion_title() {
      return this.activities.length > 1 ? this.$t('Polish Activities') : this.$t('Polish Activity');
    },
  },

  methods: {
    select(index) {
      this.selection = index;
    },
  },
}
</script>
